import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';

import { MatDatepicker } from '@angular/material/datepicker';

import * as _moment from 'moment';
import { Moment } from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ChartType, ChartData, ChartConfiguration, Chart } from 'chart.js';
import { ActivityPanelDTO, ActivityPanelResponseDTO } from '../model/activity-model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { BaseChartDirective } from 'ng2-charts';
import { ActivityStore } from '../activity-services/activity.store';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LOCALE_ES } from '@app/@core/constants/common.constants';

const moment = _moment;

@UntilDestroy()
@Component({
  selector: 'app-activityPanel',
  templateUrl: './activityPanel.component.html',
  styleUrls: ['./activityPanel.component.scss'],
})
export class PanelComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;
  public searchDataForm: FormGroup;

  public isRequestButtonDisabled: boolean = true;
  public isDatepickerDisabled: boolean = true;

  public statusRequests: CommonDataDTO[];
  public currentDate: Date = new Date();
  public subtitle: string;

  checkedDateMonth = false;
  monthsNumber: number[] = [];
  barChartLabels: string[] = [];
  loadgraphic: boolean = false;
  maxFinalDate: Date = new Date();
  minFinalDate: Date;
  minDate: Date = new Date('1/1/1900');

  public barChartLabelsName: string[] = [
    '',
    this.translateService.instant('activityPanel.chart.january'),
    this.translateService.instant('activityPanel.chart.february'),
    this.translateService.instant('activityPanel.chart.march'),
    this.translateService.instant('activityPanel.chart.april'),
    this.translateService.instant('activityPanel.chart.may'),
    this.translateService.instant('activityPanel.chart.june'),
    this.translateService.instant('activityPanel.chart.july'),
    this.translateService.instant('activityPanel.chart.august'),
    this.translateService.instant('activityPanel.chart.september'),
    this.translateService.instant('activityPanel.chart.october'),
    this.translateService.instant('activityPanel.chart.november'),
    this.translateService.instant('activityPanel.chart.december'),
  ];

  public barChartType: ChartType = 'bar';
  public barChartLegend = true;

  public barChartData: ChartData<'bar'> = {
    labels: this.barChartLabels,
    datasets: [
      {
        data: [],
        label: this.translateService.instant('activityPanel.chart.total'),
        barThickness: 6,
        backgroundColor: '#006dff',
        hoverBackgroundColor: '#006dff',
      },
      {
        data: [],
        label: this.translateService.instant('activityPanel.chart.requests'),
        barThickness: 6,
        backgroundColor: '#f6bb14',
        yAxisID: 'y-axis-1',
        hoverBackgroundColor: '#f6bb14',
      },
    ],
  };

  public barChartOptions: any = {
    options: {
      plugins: {
        tooltip: {
          enabled: true,
          mode: 'index',
          backgroundColor: '#FFFFFF',
          borderWidth: 1,
          borderColor: 'grey',
          titleColor: '#000000',
          titleFontStyle: 'bold',
          displayColors: true,
          position: 'nearest',
          callbacks: {
            title: function (tooltipItems: any, data: any) {
              return tooltipItems[0].label;
            },
            label: function (tooltipItems: any, data: any) {
              if (tooltipItems.datasetIndex === 1) {
                return tooltipItems.formattedValue + ' Solicitudes';
              } else {
                let decimales: string = tooltipItems.formattedValue.split(',')[1];
                if (decimales.length < 2) {
                  return tooltipItems.formattedValue + '0';
                } else {
                  return tooltipItems.formattedValue;
                }
              }
            },
            labelTextColor: function (tooltipItem: any, chart: any) {
              return '#000000';
            },
          },
        },
      },
      scales: {
        y: {
          min: 0,
          id: 'y-axis-0',
          position: 'right',
          ticks: {
            // min: 0,
            // max: Math.max.apply(null, this.barChartData[0].data) + 50000000,
            autoSkip: true,
            callback: function (value: any, index: any, values: any) {
              return Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR',
              }).format(value);
            },
          },
        },
      },
      legend: {
        position: 'top',
        align: 'end',
      },
    },
  };

  private dataOfGraphic: ActivityPanelResponseDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private customValidators: CustomValidatorsService,
    private translateService: TranslateService,
    private dialog: MatDialog,
    private activityStore: ActivityStore,
    readonly datepickerUtils: DatepickerUtilsService,
    readonly cdref: ChangeDetectorRef
  ) {
    this.translateService.onLangChange.subscribe(() => {
      this.updatebarChartLabelsNameAndData();
    });
  }

  ngOnInit(): void {
    this.subtitle = this.translateService.instant('request.panel.subtitle.label.lastFive');
    this.searchDataForm = this.formBuilder.group(
      {
        initialDate: ['', [Validators.required, this.customValidators.checkIsFutureDate]],
        finalDate: [{ value: '', disabled: true }, [Validators.required, this.customValidators.checkIsFutureDate]],
      },
      { validators: [this.customValidators.isDateValid('initialDate', 'finalDate', 'dateInvalid')] }
    );

    this.searchDataForm.controls.initialDate.statusChanges.subscribe((value) => {
      //si initialDate no tiene valor, reiniciamos y deshabilitamos finalDate
      if (!this.searchDataForm.controls.initialDate.value) {
        this.searchDataForm.controls.finalDate.reset();
        this.searchDataForm.controls.finalDate.disable();
      } else {
        //si initialDate tiene valor, calculamos max y min que puede tener finalDate en relación a initialDate
        const initialDateValue = this.searchDataForm?.controls?.initialDate?.value;
        this.minFinalDate = initialDateValue.toDate();
        this.maxFinalDate = moment(initialDateValue).add(11, 'months').toDate();

        if (this.searchDataForm.controls.finalDate.disabled) {
          this.searchDataForm.controls.finalDate.enable();
        }
      }
    });

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );
  }

  public loadData(searchParams: ActivityPanelDTO) {
    this.loadgraphic = false;
    this.monthsNumber = [];
    this.barChartLabels = [];
    this.activityStore
      .getActivityPanel(searchParams)
      .then(
        (data: ActivityPanelResponseDTO[]) => {
          this.dataOfGraphic = data;
          let totalAmounts: number[] = [];
          let quantitySols: number[] = [];
          this.barChartData.labels = [];

          data.forEach((item) => {
            this.monthsNumber.push(parseInt(item.month, 10));
            totalAmounts.push(item.totalAmount);
            quantitySols.push(item.quantitySol);
          });

          this.monthsNumber.forEach((item) => {
            this.barChartData.labels.push(this.barChartLabelsName[item]);
          });

          this.barChartData.datasets.forEach((dataset, index) => {
            if (index === 0) {
              dataset.data = totalAmounts;
            } else if (index > 0) {
              dataset.data = quantitySols;
            }
          });
          this.loadgraphic = true;
        },
        (error) => {
          if (error.error.status === 409) {
            this.showDialogError(this.translateService.instant('dialog.error.no.data.found'));
          } else {
            this.showDialogError(this.translateService.instant('error.pagina_403'));
          }
          this.loadgraphic = false;
        }
      )
      .finally(() => {
        this.chart?.update();
      });
  }

  private updatebarChartLabelsNameAndData(): void {
    this.barChartLabelsName = [
      '',
      this.translateService.instant('activityPanel.chart.january'),
      this.translateService.instant('activityPanel.chart.february'),
      this.translateService.instant('activityPanel.chart.march'),
      this.translateService.instant('activityPanel.chart.april'),
      this.translateService.instant('activityPanel.chart.may'),
      this.translateService.instant('activityPanel.chart.june'),
      this.translateService.instant('activityPanel.chart.july'),
      this.translateService.instant('activityPanel.chart.august'),
      this.translateService.instant('activityPanel.chart.september'),
      this.translateService.instant('activityPanel.chart.october'),
      this.translateService.instant('activityPanel.chart.november'),
      this.translateService.instant('activityPanel.chart.december'),
    ];

    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [
        {
          data: [],
          label: this.translateService.instant('activityPanel.chart.total'),
          barThickness: 6,
          backgroundColor: '#006dff',
          hoverBackgroundColor: '#006dff',
        },
        {
          data: [],
          label: this.translateService.instant('activityPanel.chart.requests'),
          barThickness: 6,
          backgroundColor: '#f6bb14',
          yAxisID: 'y-axis-1',
          hoverBackgroundColor: '#f6bb14',
        },
      ],
    };

    if (this.dataOfGraphic?.length > 0) {
      const totalAmounts: number[] = [];
      const quantitySols: number[] = [];
      this.barChartData.labels = [];

      this.monthsNumber = [];
      this.dataOfGraphic.forEach((item) => {
        this.monthsNumber.push(parseInt(item.month, 10));
        totalAmounts.push(item.totalAmount);
        quantitySols.push(item.quantitySol);
      });

      this.monthsNumber.forEach((item) => {
        this.barChartData.labels.push(this.barChartLabelsName[item]);
      });

      this.barChartData.datasets.forEach((dataset, index) => {
        if (index === 0) {
          dataset.data = totalAmounts;
        } else if (index > 0) {
          dataset.data = quantitySols;
        }
      });
    }

    this.cdref.detectChanges();
  }

  private showDialogError(error: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross', noRedirect: true };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  onFilterClick() {
    let searchParams: ActivityPanelDTO = {
      fromDate: moment(this.searchDataForm.controls.initialDate?.value).startOf('month').format('YYYY-MM-DD'),
      toDate: moment(this.searchDataForm.controls.finalDate?.value).endOf('month').format('YYYY-MM-DD'),
    };

    this.loadData(searchParams);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, input: any) {
    const inputForm = typeof input === 'string' ? input : input?.getAttribute('formControlName');
    const control: AbstractControl = this.searchDataForm.controls[inputForm];
    const ctrlValue = this.searchDataForm.controls[inputForm].value;
    console.log(normalizedMonth);
    if (ctrlValue) {
      ctrlValue.month(normalizedMonth.month());
      control.setValue(ctrlValue);
    } else {
      control.setValue(
        moment('1/' + (normalizedMonth.month() + 1).toString() + '/' + normalizedMonth.year().toString(), 'DD-MM-YYYY')
      );
    }
    datepicker.close();
  }

  chosenYearHandler(normalizedYear: Moment, input: any) {
    const inputForm = typeof input === 'string' ? input : input?.getAttribute('formControlName');
    const control: AbstractControl = this.searchDataForm.controls[inputForm];
    const ctrlValue = this.searchDataForm.controls[inputForm].value;
    if (ctrlValue) {
      ctrlValue.year(normalizedYear.year());
      control.setValue(ctrlValue);
    } else {
      control.setValue(moment('1/1/' + normalizedYear.year().toString(), 'DD-MM-YYYY'));
    }
  }

  sendDateMonth(event: any) {
    if (event.checked === true) {
      const ctrlValue = this.searchDataForm.controls['initialDate'].value;
      this.searchDataForm.controls.initialDate.setValue(moment(moment().startOf('month').format('YYYY-MM-DD')));
      this.searchDataForm.controls.initialDate.disable();
      this.searchDataForm.controls.finalDate.setValue(moment());
      this.searchDataForm.controls.finalDate.disable();
      this.checkedDateMonth = true;
    } else {
      this.searchDataForm.controls.initialDate.reset();
      this.searchDataForm.controls.finalDate.reset();
      this.searchDataForm.controls.initialDate.enable();
      this.checkedDateMonth = false;
    }
  }
}
